// extracted by mini-css-extract-plugin
module.exports = {"link":"DateForm_link__2rnUE"};